import type React from 'react';

import type { ErrorStateDetails } from 'src/app/shared/utils/async';

import type { EndorsementsPageCombinedState } from './hook';

export type EndorsementsPageErrorHandlerProps = {
	context: ErrorStateDetails<EndorsementsPageCombinedState>;
};

export const EndorsementsPageErrorHandler: React.FC<EndorsementsPageErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for endorsements page (error: ${error})`);
};
